module.exports = __webpack_public_path__ + "static/media/fig_21.5df65192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_21.jpg
// module id = 656
// module chunks = 0